<template>
<div class="article-related-panel">
  <div class="head">
    <h3>
      {{title}}
    </h3>
    <slot name="more" />
  </div>
  <ul v-if="!loading">
    <li v-for="article in list" :key="article.uuid || article.aid">
      <h6 :title="article.article_title">
        <ArticleTitle :uuid="article.uuid || article.aid" :title="article.article_title" :type="2" source="hot_talk" />
      </h6>
      <p>{{article.views}} 次围观</p>
    </li>
  </ul>
  <template v-if="loading">
    <div class="loading-panel">
      <gkLoading color="blue" />
    </div>
  </template>
</div>
</template>

<script>
import VueTypes from 'vue-types'
import {mapState} from 'vuex'

import gkLoading from 'gkui/loading'

import ArticleTitle from '../../components/title/ArticleTitle'

export default {
  name: 'article-related',
  components: {
    gkLoading,
    ArticleTitle
  },
  props: {
    title: VueTypes.string.def('热门话题'),
    list: VueTypes.array.def([]),
    loading: VueTypes.bool.def(false)
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['isMobile', 'loginUser'])
  },
  created () {
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';
.loading-panel {
  @extend %center;
  width: 100%; height: 100px;
}

.article-related-panel {
  box-sizing: border-box;
  width: 100%;
  padding: 16px 20px 15px 21px;
  background: #FFF;
  border: 1px solid $borderGray; border-radius: 3px;
}

.head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 9px 0;
}

h3 {
  position: relative;
  height: 20px;
  line-height: 20px;
  text-indent: 12px;
  @include font(20, 500);
  color: $lightBlack;
  
  &:before {
    content: ' ';
    display: block;
    position: absolute; left: 0; top: 0;
    width: 4px; height: 18px;
    background: $blue;
    border-radius: 4px;
    pointer-events: none;
  }
}
ul {
  padding-top: 2px;

  & li {
    padding: 9px 0 8px; margin: 0 5px 0 2px;
    border-bottom: 1px solid $borderGray;

    &:last-child {
      border-bottom: none;
    }
  }

  & h6 {
    margin: 0 -5px 0 -2px;
    line-height: 24px;
    text-align: justify;
    @include row(2);
    font-size: 14px;

    & ::v-deep [data-talk] {
      & .iconfont {
        font-size: 15px;
      }
    }
  }

  p {
    margin: 2px -5px 0 -2px;
    @extend %font12;
    line-height: 18px;
    color: $gray;
  }
}

@media screen and (max-width: 768px) {
  .article-related-panel {
    padding: 16px 20px 19px;
    border: none; border-radius: 0;
  }

  h3 {
    position: relative;
    height: 38px;
    line-height: 38px;
    text-indent: 12px;
    @include font(20, 500);
    
    &:before {
      content: ' ';
      display: block;
      position: absolute; left: 0; top: 9px;
      width: 4px; height: 18px;
      background: $blue;
      pointer-events: none;
    }
  }
  ul {
    padding-top: 2px;

    & li {
      padding: 9px 0; margin: 0 5px 0 2px;
      border-bottom: 1px solid $borderGray;

      &:last-child {
        border-bottom: none;
      }
    }

    & h6 {
      margin: 0 -5px 0 -2px;
      line-height: 24px;
      text-align: justify;
    }

    p {
      margin: 4px -5px 0 -2px;
      color: $gray;
    }
  }
}
</style>

 